import { Injectable } from "@angular/core";
import { ApiService } from "@edp-services/api.service";
import { TransactionHistoryRequest } from "@edp-models/transactions-history.model";
import { UserLevelRequest } from "@edp-models/user-level.model";

@Injectable({
    providedIn: "root",
})
export class LevelsService {
    constructor(private apiService: ApiService) {}

    public getHistory(args: TransactionHistoryRequest) {
        return this.apiService.callServicePostToCollection(`EdpE.User.getPointHistory`, args);
    }
}
